export default __webpack_public_path__ + "static/media/coubertin.ad7e925e.svg";